import apis from "@api/api";

export enum PlanType {
	AppStore = 'appStore',
	PlayStore = 'playStore',
	Stripe = 'stripe',
}

export default async function handleCancelPlan(type: PlanType) {
	// Implementation here
	switch (type) {
		case 'appStore': await apis.cancelApplePlan()
		case 'playStore': await apis.cancelPlayPlan()
		case 'stripe': await apis.cancelStripePlan()
	}
}
